module.exports = __webpack_public_path__ + "static/amazon-new-sellers-percentage-be8bc0b5ba3210932585447afdc64fe2.png";